module.exports = __webpack_public_path__ + "img/global-background_th9kkt_c_scale,w_3333.jpg";